import { useAuth0 } from "@auth0/auth0-react"
import React, { useContext } from "react"
import { Navigate, Route, Routes } from "react-router-dom"
import ProtectedRoute from "../../Components/BifrostPageComponent/BifrostProtectedRoute/ProtectedRoute"
import { hasFeatureInPackage, isAdmin, isSuperAdminOrResellerAdmin, isSuperAdminOrResellerAdminOrAdmin } from "../../Utils/util"
import userInfoContext from "../../store/userInfoContext"
import Error404 from "../OtherPages/ErrorPage/Error404"
import DeviceDetailsPage from "./MainPanelBody/DevicesPage/DeviceDetailsPage/DeviceDetailsPage"
import DevicesPage from "./MainPanelBody/DevicesPage/DevicesPage"
import GroupDetailPage from "./MainPanelBody/Groups/GroupDetail/GroupDetailPage"
import GroupsPage from "./MainPanelBody/Groups/GroupsPage"
import OrganizationsPage from "./MainPanelBody/Organizations_Activity/OrganizationsPage"
import ActivityPage from "./MainPanelBody/Organizations_Activity/OrgannizationInfo_ActitvtyPage/ActivityPage"
import OrganizationView from "./MainPanelBody/Organizations_Activity/OrgannizationInfo_ActitvtyPage/OrganizatianInfoPage/OrganizationView"
import UserDetailPage from "./MainPanelBody/Users/UserDetails/UserDetailPage"
import UsersPage from "./MainPanelBody/Users/UsersPage"

const MainPanel = () => {
	const { user } = useAuth0()
	const userInfo = useContext(userInfoContext)

	return (
		<main>
			<Routes>
				<Route path="/" element={<Navigate to="/devices" />} />
				<Route path="/devices" element={<ProtectedRoute component={DevicesPage} />} />
				{isSuperAdminOrResellerAdminOrAdmin(user) && (
					<>
						<Route path="/devices/:id" element={<ProtectedRoute component={DeviceDetailsPage} />} />
						{process.env.REACT_APP_SAML_ENABLED !== "true" && (
							<>
								<Route path="/users" element={<ProtectedRoute component={UsersPage} />} />
								<Route path="/users/:id" element={<ProtectedRoute component={UserDetailPage} />} />
								{hasFeatureInPackage(userInfo, "groups") && (
									<>
										<Route path="/groups" element={<ProtectedRoute component={GroupsPage} />} />
										<Route path="/groups/:id" element={<ProtectedRoute component={GroupDetailPage} />} />
									</>
								)}
							</>
						)}
					</>
				)}
				{isAdmin(user) && <Route path="/activity" element={<ProtectedRoute component={ActivityPage} />} />}
				{isSuperAdminOrResellerAdmin(user) && (
					<>
						<Route path="/orgs" element={<ProtectedRoute component={OrganizationsPage} />} />
						<Route path="/orgs/:id" element={<ProtectedRoute component={OrganizationView} />} />
					</>
				)}
				<Route path="*" element={<Error404 />} />
			</Routes>
		</main>
	)
}

export default MainPanel
